import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const TILES = [
  { n: "01", name: "Tool Backpacks", img: "/images/pack_angle.png", span: "md:col-span-2 md:row-span-2", tag: "Flagship Line" },
  { n: "02", name: "Tool Storage", img: "/images/cat_storage.png", span: "md:col-span-2", tag: "Modular Systems" },
  { n: "03", name: "Work Gear", img: "/images/cat_gear.png", span: "md:col-span-2", tag: "Everyday Carry" },
  { n: "04", name: "Accessories", img: "/images/detail_zipper.png", span: "md:col-span-2", tag: "Built to Match" },
];

export default function Categories() {
  return (
    <section id="products" data-testid="categories-section" className="mx-auto max-w-[1600px] px-6 py-28 md:px-12 md:py-40">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <SectionLabel index="02" title="Categories" />
          <h2 className="mt-8 font-display text-4xl font-semibold uppercase leading-none tracking-tight text-zinc-50 sm:text-5xl lg:text-7xl">
            The Lineup
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-zinc-500">
          Four lines. One standard. Engineered in Texas for the people who build everything else.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-4 md:mt-20 md:grid-cols-4 md:auto-rows-[280px]">
        {TILES.map((t, i) => (
          <Reveal key={t.n} delay={0.06 * i} className={t.span} y={20}>
            <button
              data-testid={`category-tile-${t.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative block h-64 w-full overflow-hidden border border-zinc-800 text-left md:h-full"
            >
              <img
                src={t.img}
                alt={t.name}
                className="absolute inset-0 h-full w-full object-cover opacity-70 transition-[opacity,transform] duration-700 ease-out group-hover:scale-[1.04] group-hover:opacity-90"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-6">
                <div>
                  <span className="text-[10px] uppercase tracking-[0.3em] text-zinc-400">{t.n} — {t.tag}</span>
                  <h3 className="mt-2 font-display text-2xl font-semibold uppercase tracking-tight text-zinc-50 sm:text-3xl">
                    {t.name}
                  </h3>
                </div>
                <ArrowUpRight size={22} className="text-zinc-400 transition-[color,transform] duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-zinc-50" />
              </div>
            </button>
          </Reveal>
        ))}

        <Reveal delay={0.24} className="md:col-span-2" y={20}>
          <div
            data-testid="category-tile-coming-soon"
            className="relative flex h-64 flex-col justify-between overflow-hidden border border-zinc-800 bg-[#111111] p-6 md:h-full"
          >
            <span className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">05 — In Development</span>
            <div>
              <h3 className="font-display text-2xl font-semibold uppercase tracking-tight text-zinc-50 sm:text-3xl">
                Coming Soon
              </h3>
              <p className="mt-3 max-w-xs text-sm leading-relaxed text-zinc-500">
                CHWA-02, CHWA-03, CHWA-04. Professional tools and apparel — engineered to the same standard.
              </p>
              <span className="mt-5 inline-block border border-zinc-700 px-4 py-2 text-[10px] uppercase tracking-[0.3em] text-zinc-400">
                2026 — 2027
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
